import styled from '@emotion/styled';

export const PowerKeyModeHint: React.FC = () => {
  return (
    <Container>
      <span>
        <strong>None:</strong> Mode is undefined or unknown.
      </span>
      <span>
        <strong>No Power Off:</strong> The power key will not turn off the device.
      </span>
      <span>
        <strong>Power Off:</strong> The power key will turn off the device.
      </span>
      <span>
        <strong>SOS Mode:</strong> Long press activates SOS mode.
      </span>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
